
import { formatText } from '../lib/utils';
import { motion } from 'framer-motion';

const Services = () => {
  const services = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-megaphone-icon lucide-megaphone">
          <path d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"></path>
          <path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14"></path>
          <path d="M8 6v8"></path>
        </svg>
      ),
      label: "Meta Ads"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-layout-template-icon lucide-layout-template">
          <rect width="18" height="7" x="3" y="3" rx="1"></rect>
          <rect width="9" height="7" x="3" y="14" rx="1"></rect>
          <rect width="5" height="7" x="16" y="14" rx="1"></rect>
        </svg>
      ),
      label: "Landing Page"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-film-icon lucide-film">
          <rect width="18" height="18" x="3" y="3" rx="2"></rect>
          <path d="M7 3v18"></path>
          <path d="M3 7.5h4"></path>
          <path d="M3 12h18"></path>
          <path d="M3 16.5h4"></path>
          <path d="M17 3v18"></path>
          <path d="M17 7.5h4"></path>
          <path d="M17 16.5h4"></path>
        </svg>
      ),
      label: "Video Reklamy"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-tablet-smartphone-icon lucide-tablet-smartphone">
          <rect width="10" height="14" x="3" y="8" rx="2"></rect>
          <path d="M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4"></path>
          <path d="M8 18h.01"></path>
        </svg>
      ),
      label: "Google Ads"
    }
  ];

  return (
    <motion.section
      id="services"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="flex flex-col border-double border-b-[1px] border-l-[0px] opacity-[100%] border-r-[0px] border-t-[0px] border-[#525252] md:pb-[6rem] sm:pb-[5rem] pb-[5rem] lg:pb-[120px] md:pt-[6rem] sm:pt-[5rem] pt-[5rem] lg:pt-[120px] xl:w-[100%] xl:max-w-[auto] w-[100%] max-w-[auto] ml-[auto] mr-[auto]"
    >
      <div className="flex flex-col w-[100%] max-w-[1280px] mr-[auto] ml-[auto] md:pr-[4rem] sm:pr-[4rem] pr-[1.5rem] lg:pr-[32px] md:pl-[4rem] sm:pl-[4rem] pl-[1.5rem] lg:pl-[32px] 2xl:max-w-[1536px]">
        <div className="flex flex-col md:gap-[4rem] sm:gap-[4rem] gap-[4rem] lg:gap-[72px]">
          <div className="flex flex-col gap-[2rem] sm:gap-[3rem]">
            <h2 className="text-[36px] sm:text-[48px] font-semibold block leading-[1.25em] sm:leading-none">{formatText("Jakie usługi oferujemy?")}</h2>
            <p className="text-[18px] text-[#a3a3a3] w-[60%] opacity-[100%]">{formatText("Kompleksowe wsparcie w digital marketingu. Specjalizujemy się w precyzyjnie targetowanych kampaniach Meta Ads (Facebook & Instagram) oraz Google Ads, które docierają do Twoich idealnych klientów. Tworzymy również konwertujące Landing Pages oraz angażujące Video Reklamy.")}</p>
          </div>
          <div className="grid gap-[12px] grid-cols-1 sm:grid-cols-4 pt-[0px] pb-[0px] pl-[0px] pr-[0px]">
            {services.map((service, index) => (
              <motion.div
                key={index}
                transition={{ type: "spring", stiffness: 300 }}
                className="flex gap-[8px] sm:gap-[12px] w-[auto] items-center justify-center flex-col border-[1px] border-[#525252] rounded-[8px] space-y-[0px] pl-[2rem] pr-[2rem] pt-[2rem] pb-[2rem] cursor-pointer group"
              >
                <motion.i
                  className="block h-[auto] w-[auto] text-[#a3a3a3] group-hover:text-white transition-colors duration-300 transform"
                >
                  {service.icon}
                </motion.i>
                <span className="text-[18px] block text-center text-[#a3a3a3] group-hover:text-white transition-colors duration-300">{service.label}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Services;
